<template>
    <div class="base-wrapper">
    <div :class="{'uk-card-default': true, 'chartcard': true, fullscreen: fullscreen}">
      <a v-if="fullscreen" class="uk-alert-close" @click="() => {fullscreen=false; $store.dispatch('showHeader')}" uk-close></a>
      <a v-if="!fullscreen"class="uk-alert-close" uk-icon="icon: expand" @click="() => {fullscreen=true; $store.dispatch('hideHeader')}"></a>

      <div class="survey-section">
        <div class="uk-grid">
          <div class="uk-width-1-4@m graph-controller uk-grid-margin-small">

            <ul class="uk-flex-center graph-controller-tabs" uk-tab>
              <li id="chart-presets" :class="{'uk-active': controllerMode === 'presets'}"><a href="#"
                                                                                             @click="controllerMode = 'presets'"><span
                      uk-icon="icon: play"></span></a></li>
              <li id="chart-settings" :class="{'uk-active': controllerMode === 'settings'}"><a href="#"
                                                                                               @click="controllerMode = 'settings'"><span
                      uk-icon="icon: settings"></span></a></li>
            </ul>
            <!-- options accordion -->

            <div class='graph-controller-body uk-padding-small'>

              <!--  DEFAULT CHARTS HTML -->

            <div v-if="controllerMode === 'presets'">
              <ul uk-accordion="multiple: true" id="prebuilt-chart-selector">
               <li>TEST</li>
                </ul>

              </div>


              <!--  SETTINGS HTML -->
              <div v-if="controllerMode === 'settings'">
                <h4 class="control-section-header">Chart Settings</h4>
                <ul uk-accordion="multiple: true">
                    <li class="uk-open">
                        <a class="uk-accordion-title" href="#">View data as:</a>
                        <div class="uk-accordion-content">
                            <div v-for="presentation in presentations">
                                <Chip
                                        class="list-group-item"
                                        :key="presentation.name"
                                        :data="presentation"
                                        :removeable="false"
                                        @clickEvent="singleSurvey= {
                                                            active: false,
                                                            sc_id: null,
                                                            sc_dt: null,
                                                        };
                                                        loadPresentation(presentation);"
                                />
                            </div>
                        </div>
                    </li>

                    <li class="uk-open" v-if="selectedPresentation == 'surveyEmulator'">
                        <a class="uk-accordion-title" href="#">Survey Type</a>
                        <div class="uk-accordion-content">
                        <button class="uk-button uk-button-primary" style="margin: 5px;" @click="getSurveys">Update</button>
                        <select v-model="surveyType" class="uk-select" type="select">
                            <option value="STD12E">Email</option>
                            <option value="STD12M">Mail</option>
                        </select>
                        </div>

                    </li>
                    <li v-if="selectedPresentation == 'surveyEmulator'">
                        <a class="uk-accordion-title" href="#">Survey Answer Filters</a>
                        <div class="uk-accordion-content">
                                <div v-for="f in Object.keys(filters.values)" class="filter-form">
                                    <input class="uk-checkbox" @click="checkActives" value="checked" type="checkbox" v-model="filters.values[f].apply">
                                    {{filters.values[f].name}}
                                    <div uk-grid>
                                        <div class="uk-width-expand@m">
                                            <select v-model="filters.values[f].comparison" class="uk-select">
                                                <option value="is">Equal To</option>
                                                <option value="isnt">Is not Equal To</option>
                                                <option value="lt">Better</option>
                                                <option value="gt">Worse</option>
                                            </select>
                                        </div>
                                        <div class="uk-width-expand@m">
                                            <select v-model="filters.values[f].filter_value" class="uk-select">
                                                <option value=1>{{satWord(1)}}</option>
                                                <option value=2>{{satWord(2)}}</option>
                                                <option value=3>{{satWord(3)}}</option>
                                                <option value=4>{{satWord(4)}}</option>
                                                <option value=5>{{satWord(5)}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </li>



<!--                    Comment finder settings-->
                    <li class="uk-open" v-if="selectedPresentation == 'commentFinder'">
                        <div class="uk-button uk-button-primary" @click="searchComments">
                            <span class="icon" uk-icon="icon: search"></span>
                            Go
                        </div>
                        <a class="uk-accordion-title" href="#">Comment Keyword Search</a>
                        <div class="uk-accordion-content">
                            <float-field-input
                                    :data="{placeholder: 'agent weather', label:'Search Comments'}"
                                    @inputevent="(input) => {commentQuery=input}">
                            </float-field-input>
                            <input class="uk-checkbox" value="checked" type="checkbox" v-model="use_related_terms"> Use
                            Related Terms
                        </div>
                    </li>
                    <li class="uk-open" v-if="selectedPresentation == 'commentFinder'">
                        <a class="uk-accordion-title" href="#">Sentiment Scale</a>
                        <div class="uk-accordion-content">
                            <div class="uk-grid-divider" uk-grid>
                                <div class="uk-width-expand@m"><span uk-icon="warning" style="color: red"></span></div>
                                <div class="uk-width-expand@m"><span uk-icon="happy" class="uk-position-right"
                                                                     style="color: darkgreen"></span></div>
                            </div>

                            <input v-model="sentiment" class="uk-range" type="range">
                            <div class="uk-grid-divider" uk-grid>
                                <div class="uk-width-expand@m">
                                    <select v-model="sentiment_operator" class="uk-select" type="select">
                                        <option value="lt">Worse</option>
                                        <option value="gt">Better</option>
                                    </select>
                                </div>
                                <div class="uk-width-expand@m">
                                    <p v-bind:style="{color: sentimentColor}">{{converted_sentiment_operator}}
                                        {{convertedScaledSentiment}}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <a class="uk-accordion-title" href="#">From Date</a>
                        <div class="uk-accordion-content">
                            <!--disable before Jan 1 2017-->
                            <Datepicker
                                    :value="surveysFrom"
                                    :inline="true"
                                    v-model="surveysFrom"
                                    @selected="refresh++"
                            />
                        </div>
                    </li>
                    <li>
                        <a class="uk-accordion-title" href="#">To Date</a>
                        <div class="uk-accordion-content">
                            <!--disable before Jan 1 2017-->
                            <Datepicker
                                    :value="surveysTo"
                                    :inline="true"
                                    v-model="surveysTo"
                                    @selected="refresh++"
                            />
                        </div>
                    </li>
                </ul>

                        <div v-if="query_terms" class="search-terms">
                            <div v-for="cat in query_terms">
                                <H4> Related Terms Used in Search</H4>
                                <p v-for="term in cat">{{term}}</p>
                            </div>
                        </div>


              </div>
            </div>
          </div>
          <div class="uk-width-3-4@m uk-flex-center">
                  <alert
                          v-if="error"
                          class="uk-alert-danger"
                          :data="{body: error,
                                  icon:'warning',
                                  }"
                  />

              <!--THIS IS WHERE THE CHARTS LIVE-->
              <h3  class="no-data-warning" v-if="noData">There is no data to display.</h3>
              <div class="survey-viewer" v-if="selectedPresentation == 'commentFinder'" uk-scroll>
                  <h3 v-if="selectedPresentation == 'commentFinder' && !noData">Comments</h3>
                  <div v-for="(comment, i) in commentFinder.comments">
                      <comment :data="comment" @singleSurvey="(input)=>{singleSurvey=input; getSurveys(); loadPresentation(presentations[1]);}"></comment>
                  </div>
              </div>
                <div class="survey-viewer" v-if="selectedPresentation == 'surveyEmulator' && !noData" uk-scroll>
                    <div id="settingsDisplay" v-if="selectedPresentation == 'surveyEmulator' && !noData">
                          <h3 >{{surveyType}} Surveys</h3>
                        <div class = uk-card-body>
                        <table class="uk-table uk-table-hover">
                            <tbody>
                                <tr>
                                    <td>Starting From</td>
                                    <td></td>
                                    <td>{{cleanTimeParam.from}}</td>
                                </tr>
                                <tr>
                                    <td>Going To</td>
                                    <td></td>
                                    <td>{{cleanTimeParam.to}}</td>
                                </tr>
                                <tr v-for="f in filters.values" v-if="f.apply">
                                    <td>{{f.name}}</td>
                                    <td>{{f.comparison.toUpperCase()}}</td>
                                    <td>{{satWord(f.filter_value)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>

                    <generated-document :documents="documents"></generated-document>
              </div>

          </div>
        </div>
      </div>

    </div>
      <spinner-overlay v-show="showOverlay"/>
    <Demo v-if="surveyDemo" showName="surveys"></Demo>
  </div>
</template>

<script>
    import Demo from "./theme/Demo"
    import SpinnerOverlay from "./theme/SpinnerOverlay"
    import Alert from "./theme/Alert"
    import Chip from "./theme/Chips"
    import Comment from "./theme/Comment"
    import FloatFieldInput from "./theme/Input";
    import api from '../store/apicall'
    import Datepicker from 'vuejs-datepicker';
    import Moment from 'moment';
    import GeneratedDocument from "./theme/GeneratedDocument";

    function perc2color(perc) {
        var r, g, b = 0;
        if (perc < 50) {
            r = 255;
            g = Math.round(5.1 * perc);
        } else {
            g = 255;
            r = Math.round(510 - 5.10 * perc);
        }
        var h = r * 0x10000 + g * 0x100 + b * 0x1;
        return '#' + ('000000' + h.toString(16)).slice(-6);
    }

    export default {
        name: "surveys",
        components: {GeneratedDocument, Demo,SpinnerOverlay, Alert, Chip, Comment, FloatFieldInput, Datepicker},
        data: function() {
            return {

                filters: {
                   surveyEmulator: {
                       STD12E: [['Overall_Sat', 'outc1'], ['Response_Sat', 'q24'], ['Request_Service_Sat', 'driver5'],
                           ['Keeping_Members_Informed_Sat', 'q26'], ['Facility_Sat', 'driver10']]
                   },
                    values: {

                    }
                },
                visibleSurvey: {},
                surveyType: 'STD12E',
                surveyDemo: false,
                surveysFrom:  new Date().setMonth(new Date().getMonth() - 1),
                surveyCounter: 0,
                surveysTo: new Date(),
                noData: true,
                error: false,
                controllerMode: 'settings',
                fullscreen: false,
                showOverlay: false,
                use_related_terms: true,
                presentations: [{
                    displayName: 'Comment Finder',
                    name: 'commentFinder'
                },{
                    displayName: 'Survey Emulator',
                    name: 'surveyEmulator'
                }],
                selectedPresentation: null,
                commentFinder : {
                    comments: []
                },
                commentQuery: "",
                sentiment: 0,
                sentiment_operator: 'gt',
                sentimentColor: '#375A8B',
                surveyData: [],
                query_terms: null,
                // defaultFrom: new Moment().subtract(1, "month"),
                // defaultTo: new Moment(),
                first_comment_pull : true,
                singleSurvey: {
                    active: false,
                    sc_id: null,
                    sc_dt: null,
                },
                filter_applied: false

            }
        }, methods: {
            checkActives: function() {
              console.log("ACTIVES", this.activeFilters, this.noData)
                if (this.noData && this.activeFilters.length > 0){
                    this.getSurveys()
                }
            },
            satWord: function(word){
                let conversion = {
                    1: 'Totally Satisfied',
                    2: 'Satisfied',
                    3: 'Neither Satisfied nor Dissatisfied',
                    4: 'Dissatisfied',
                    5: 'Totally Dissatisfied',
                    6: 'Cant say'
                }
                return conversion[word]
            },
            generateSettings: function(presentation){
                let settingFilters = this.filters[presentation.name][this.surveyType]
                let _t = this
                settingFilters.forEach(function(el){
                    _t.$set(_t.filters.values, el[0], {})
                    _t.$set(_t.filters.values[el[0]], 'apply', false);
                    _t.$set(_t.filters.values[el[0]], 'comparison', 'is')
                    _t.$set(_t.filters.values[el[0]], 'filter_value', 1)
                    _t.$set(_t.filters.values[el[0]], 'name', el[0].split('_').join(" "))
                    _t.$set(_t.filters.values[el[0]], 'field', el[1])
                })
            },

            loadPresentation: function(presentation){
                // console.log(presentation)
                this.selectedPresentation = presentation.name
                if (presentation.name=='commentFinder'){
                    this.first_comment_pull=true
                    this.searchComments()
                } else if (presentation.name=='surveyEmulator'){
                    this.generateSettings(presentation)
                    this.showOverlay = true;
                    // console.log(this.showOverlay);
                    this.getSurveys()
                }
            },
            getSurveys: function() {
                let request = {
                    purpose: "survey_finder",
                    slug: this.slug,
                    type: this.slugType,
                    parameters: this.requestParameters

                };

                const _t = this
                console.log("REQUEST", request)
                api.post('/dashboard/', request).then(function (response) {
                    _t.showOverlay=false;
                    _t.surveyData = []

                    let data = response.data.data;
                    let metaData = response.data.metadata;
                    let newMetaData = {}

                    console.log("DATA", data)
                    metaData.forEach(function (el) {
                        el.question_options = JSON.parse(el.question_options)
                        newMetaData[el.field.toLowerCase()] = el
                    });

                    if (!Array.isArray(data)) {
                        data = [data]
                    }
                    console.log("METADATA", newMetaData)
                    data.forEach(function (d) {
                        console.log(d)
                        _t.noData = false;
                        let i = 0
                        _t.surveyData.push(Object.keys(d).map(x => {
                            i+=1
                            x = x.toLowerCase()
                            if (newMetaData[x]) {
                                let output = {metaData: newMetaData[x]}
                                if (newMetaData[x]['question_options']) {
                                    output['originalValue'] = d[x]
                                    output['value'] = newMetaData[x]['question_options'][d[x]]
                                } else {
                                    output['originalValue'] = d[x]
                                    output['value'] = d[x]
                                }
                                return output
                            } else {
                                console.log(x, newMetaData)
                                return {
                                    originalValue: d[x],
                                    value: d[x],
                                    metaData: x,
                                }
                            }

                        }))

                    })

                }).catch(function(error) {
                    console.log(error)
                })
            },

            searchComments: function() {

                this.showOverlay=true
                let request = {
                    purpose: "survey_comments",
                    slug: this.slug,
                    type: this.slugType,
                    parameters: {
                        search: this.commentQuery.split(' '),
                        sentiment: this.scaledSentiment,
                        sentiment_operator: this.sentiment_operator,
                    }

                };

                if (this.surveysFrom){
                    request.parameters['from'] = Moment(this.surveysFrom).format('YYYY-MM-DD')
                }

                if (this.surveysTo){
                    request.parameters['to'] = Moment(this.surveysTo).format('YYYY-MM-DD')
                }

                let skip_terms = !this.use_related_terms
                if (skip_terms || this.first_comment_pull){
                    request.parameters['skip_related_words'] = 1
                }
                this.first_comment_pull=false;

                console.log("COMMENTS REQUEST", request)
                let _t = this;
                api.post('/dashboard/', request).then(function(response){
                    _t.commentFinder.comments = []
                    console.log(response.data)
                    let data = response.data.data
                    _t.query_terms = response.data.query_terms_used;
                    data.forEach(function(el, idx){

                        _t.commentFinder.comments.push({
                            odd: idx%2,
                            id: el['sc_id'],
                            message: el['q30'],
                            source: el['svc_facl_id'],
                            time: el['sc_dt']

                        })
                    })
                    _t.noData = false;
                    _t.showOverlay=false
                }).catch(function(error){
                    _t.error = error
                })

                console.log(this.commentQuery)
            }
        },

        computed: {

            cleanTimeParam: function() {
                return {
                    from: Moment(this.surveysFrom).format("MMMM DD, YYYY"),
                    to: Moment(this.surveysTo).format("MMMM DD, YYYY")
                }
            },

            activeFilters: function(){
                let actives = []
                let _t = this
                Object.keys(this.filters.values).forEach(function (k){
                    let el = _t.filters.values[k]
                    if(el.apply){
                        actives.push(el)
                    }
                })
                if (actives.length == 0){
                    console.log("NO ACTIVES")
                }
                return actives
            },

            documents: function() {
                this.noData = false;
                let _t = this;
                let documents = []
                    if (this.activeFilters.length > 0) {
                        console.log("ACTIVE FILTERS")
                        this.activeFilters.forEach(function (f) {
                            if (f.apply) {
                                var compare = function () {
                                }
                                var filter_value = f.filter_value;

                                if (f.comparison == 'gt') {
                                    compare = function (value) {
                                        return value > filter_value
                                    }
                                } else if (f.comparison == 'is') {
                                    compare = function (value) {
                                        return value == filter_value
                                    }
                                } else if (f.comparison == 'isnt') {
                                    compare = function (value, filter_value) {
                                        return value != filter_value
                                    }
                                } else if (f.comparison == 'lt') {
                                    compare = function (value, filter_value) {
                                        return value < filter_value
                                    }
                                } else {
                                    compare = function () {
                                        console.log("something went wrong", f)
                                    }
                                }
                                // console.log(_t.surveyData)

                                let filter_applied = documents.length > 0
                                console.log("FILTER APPLIED", filter_applied)

                                _t.surveyData.forEach(function (doc) {
                                    doc.forEach(function (metric) {
                                        if ('metaData' in metric) {
                                            if (metric.metaData.field == f.field) {
                                                // console.log(metric, f)
                                                if (compare(metric.originalValue)) {
                                                    if (!filter_applied) {
                                                        documents.push(doc)
                                                    }

                                                } else if (documents.indexOf(doc) != -1) {
                                                    var index = documents.indexOf(doc)
                                                    documents.splice(index, 1)
                                                    console.log("removed document")

                                                }
                                            }
                                        }
                                    })
                                })

                            }
                        });

                        if (documents.length == 0) {
                            this.noData = true
                        } else {
                            this.noData = false
                            console.log("NEW DOCUMENTS", documents)
                            return documents
                        }

                    } else {
                        this.noData=false
                        console.log("NO FILTER BEING APPLIED")
                        // this.current_documents = _t.surveyData
                        return _t.surveyData
                    }
                return _t.surveyData
            },
            requestParameters: function() {
                let output = {
                    survey_type: this.surveyType,
                };

                if (this.singleSurvey['active']){
                    output['singleSurvey'] = 1;
                    output['sc_id'] = this.singleSurvey['sc_id']
                    output['sc_dt'] = this.singleSurvey['sc_dt']
                    return output
                }

                if (this.surveysFrom){
                    output['from'] = Moment(this.surveysFrom).format('YYYY-MM-DD')
                }
                if (this.surveysTo){
                    output['to'] = Moment(this.surveysTo).format('YYYY-MM-DD')
                }
                let _t = this
                Object.keys(this.filters.values).forEach(function(k){
                    let el = _t.filters.values[k]
                    if (el.apply){
                        output[k+'_comparison'] = el.comparison;
                        output[k+'_value'] = el.filter_value;
                    }
                })

                return output

            },
            slug: function () {
                return this.$store.state.geography.data.slug;
            },
            isEmployee: function () {
                return this.$store.state.geography.data.first_name;
            },
            slugType: function () {
                let geography = this.$store.state.geography;
                if (geography.data.first_name) {
                    return this.$store.state.geography.data.position_type;
                } else {
                    return this.$store.state.geography.data.type;
                }

            },
            scaledSentiment: function() {
                console.log(this.sentiment)
                this.sentimentColor = perc2color(this.sentiment);
                let sentiment = this.sentiment * 2;
                sentiment = sentiment - 100;
                sentiment = sentiment/100
                return sentiment
            },
            convertedScaledSentiment: function() {
                if (this.scaledSentiment > 0.5) {
                    return "Very Positive"
                } else if (this.scaledSentiment > -0.5 && this.scaledSentiment < 0.5) {
                    return "So So"
                } else {
                    return "Very Negative"
                }
            },
            converted_sentiment_operator: function() {
                if (this.sentiment_operator == 'gt') {
                    return "Better Than "
                } else {{
                    return " Worse Than "
                }}
            }
        }
    }
</script>

<style scoped>
.survey-viewer{
    margin: 50px;
    max-height: 600px;
    overflow-y: auto;
}
    .search-terms{
        max-height: 200px;
        overflow-y: auto;
    }

    .filter-form{
        margin: 10px;
    }
</style>
